import { render } from "./Sage.vue?vue&type=template&id=3b63ed38&scoped=true"
import script from "./Sage.vue?vue&type=script&lang=js"
export * from "./Sage.vue?vue&type=script&lang=js"

import "./Sage.vue?vue&type=style&index=0&id=3b63ed38&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b63ed38"]])

export default __exports__